var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('keep-alive',[_c(_vm.currentComponent,{tag:"component",attrs:{"printall":_vm.printall,"mobile":_vm.mobile,"email":_vm.email,"applications":_vm.applications,"applicationId":_vm.applicationId,"applicantName":_vm.applicantName,"applicantData":_vm.applicantData,"application_number":_vm.application_number}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }